import { useState } from "react";
import { ImageIcon } from "lucide-react";

/**
 * Renders the client's real asset once it exists in /public/assets,
 * a curated remote fallback until then, or an on-brand placeholder tile
 * when no fallback is defined.
 */
export const AssetImage = ({
  asset,
  alt = "",
  className = "",
  placeholderLabel,
  placeholderSub = "Actual photo coming soon",
}) => {
  const [failed, setFailed] = useState(!asset.local);

  if (failed && !asset.fallback) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-2 bg-forest-light/10 border border-dashed border-forest-light/40 text-center ${className}`}
        data-testid={`asset-placeholder-${placeholderLabel?.toLowerCase().replace(/[^a-z0-9]+/g, "-") || "image"}`}
      >
        <ImageIcon className="h-7 w-7 text-forest-light/60" strokeWidth={1.5} />
        {placeholderLabel && (
          <span className="font-display text-lg text-forest px-4">{placeholderLabel}</span>
        )}
        <span className="text-[11px] uppercase tracking-[0.18em] text-[#4A4C4A]/70 px-4 pb-1">
          {placeholderSub}
        </span>
      </div>
    );
  }

  return (
    <img
      src={failed ? asset.fallback : asset.local}
      onError={() => !failed && setFailed(true)}
      alt={alt}
      loading="lazy"
      className={className}
    />
  );
};
